export const DNI_FOREIGN_CHECK = /^[a-zA-Z0-9-]*$/
export const ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK = /^[a-zA-ZÀ-ÿ0-9\u00f1\u00d1\s.,_!¡?¿-]+$/
export const ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_FORMAT = /[^a-zA-ZÀ-ÿ0-9\u00f1\u00d1\s.,_!¡?¿-]/g
export const PATH_PARAM = /:\w+(\(\w+(\|\w+)+\))?(?=\/?)/
export const URL_CHECK =
  /^https?:\/\/(www\.)?[a-zA-Z0-9@:%._+-~#=]{1,256}\.[a-zA-Z0-9]{1,6}\b([a-zA-Z0-9@:%._+-~#=?&/]*)$/
